module.exports = "<!-- Document Wrapper\n============================================= -->\n<div id=\"wrapper\" class=\"clearfix\" appFunctions>\n\n    <app-header></app-header>\n\n    <router-outlet></router-outlet>\n\n    <app-footer-link-area></app-footer-link-area>\n    <app-footer></app-footer>\n\n</div>\n<!-- #wrapper end -->"


//////////////////
// WEBPACK FOOTER
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main